export default __webpack_public_path__ + "static/media/tv-crp.a95cc043.png";